import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import SearchIcon from '@mui/icons-material/Search'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

import useSearchBar from './useSearchBar'

const SearchBar = () => {
  const { results, open, setOpen, loading, query, setQuery, reset } =
    useSearchBar()
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  return (
    <Box sx={{
      alignItems: 'center',
      gap: 0, // Remove gap to combine elements
      position: 'relative',
      display: {
        xs: 'none',
        sm: 'flex'
      },
    }}>
      <Autocomplete
        id="fleet-search"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        loading={loading}
        options={results}
        blurOnSelect={true}
        clearOnBlur={true}
        inputValue={query}
        getOptionLabel={(option) => {
          return option.label
        }}
        isOptionEqualToValue={(option) => {
          return option.vehicle.vin
        }}
        onChange={(evt, option) => {
          option.navigateTo()
          reset()
        }}
        sx={{
          minWidth: 280, // Slightly reduced width
          '& .MuiOutlinedInput-root': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            height: '40px', // Reduced height
            paddingRight: '0px !important',
          }
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              variant="outlined"
              value={query}
              placeholder="Search by VIN"
              onChange={(evt) => {
                setQuery(evt.target.value)
              }}
              slotProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <SearchIcon style={{ color: themeColors.buttonColor, marginLeft: '8px' }} />
                  </>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '40px',
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  '& fieldset': {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                  '&:hover fieldset': {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                  '&.Mui-focused fieldset': {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                }
              }}
            />
          )
        }}
      />
      <Button
        variant="contained"
        sx={{
          backgroundColor: themeColors.buttonColor,
          color: 'white',
          textTransform: 'none',
          minWidth: '80px',
          height: '40px', // Match the reduced height
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: '20px', // Half circle edge
          borderBottomRightRadius: '20px', // Half circle edge
          marginLeft: '-1px', // Overlap border to create seamless appearance
          '&:hover': {
            backgroundColor: themeColors.buttonHover,
          }
        }}
        onClick={() => {
          // Handle search click if needed
          if (query && results.length > 0) {
            results[0].navigateTo()
            reset()
          }
        }}
      >
        Search
      </Button>
    </Box>
  )
}

export default SearchBar
